import { useState } from 'react';
import { HelpCircle } from 'lucide-react';
import { getGuideById } from '../data/guides';
import HelpPanel from './HelpPanel';

interface HelpButtonProps {
  featureId: string;
  className?: string;
}

export default function HelpButton({ featureId, className = '' }: HelpButtonProps) {
  const [showPanel, setShowPanel] = useState(false);
  const guide = getGuideById(featureId);

  if (!guide) {
    return null;
  }

  return (
    <>
      <button
        onClick={() => setShowPanel(true)}
        className={`p-2 hover:bg-slate-100 rounded-lg transition-colors text-slate-500 hover:text-primary-600 ${className}`}
        title={`Help with ${guide.title}`}
      >
        <HelpCircle className="w-5 h-5" />
      </button>

      {showPanel && (
        <HelpPanel guide={guide} onClose={() => setShowPanel(false)} />
      )}
    </>
  );
}
